import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=4779ae11"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/mahalo_integrador/hiopos/reports-co/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4779ae11')) {
      api.createRecord('4779ae11', component.options)
    } else {
      api.reload('4779ae11', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=4779ae11", function () {
      api.rerender('4779ae11', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/app/invoices/Index.vue"
export default component.exports